import { render, staticRenderFns } from "./Netbank.vue?vue&type=template&id=0a49ded2&"
import script from "./Netbank.vue?vue&type=script&lang=js&"
export * from "./Netbank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports